import { cloudStorage } from '@telegram-apps/sdk';
import { useCallback, useEffect, useState } from 'react';

import { getFromStore } from '~/app/services/cloudStore/getFromStore';
import { setToStore } from '~/app/services/cloudStore/setToStore';

const KEY = 'last_login';

export const useStorageLogin = () => {
  const [login, setLogin] = useState<string | null>(null);
  const cloudStorageIsReady = cloudStorage?.isSupported?.() ?? false;

  const saveLogin = async (value: string) => {
    setLogin(value);

    if (cloudStorageIsReady) {
      try {
        await setToStore(KEY, value);
      } catch (error) {
        console.warn('Failed to save login to cloud storage:', error);
      }
    }
  };

  const loadLogin = useCallback(async () => {
    if (!cloudStorageIsReady) {
      return;
    }

    try {
      const storedLogin = await getFromStore<string | null>(KEY);
      if (storedLogin) {
        setLogin(storedLogin);
      }
    } catch (error) {
      console.warn('Failed to load login from cloud storage:', error);
    }
  }, [cloudStorageIsReady]);

  useEffect(() => {
    if (cloudStorageIsReady) {
      loadLogin();
    }
  }, [cloudStorageIsReady, loadLogin]);

  return { login, saveLogin };
};
